import React from 'react';
import { NOMBRE_APP } from '../config/marca';

interface LogoProps {
  size?: number;
  className?: string;
  /** Sobre un fondo siempre claro (la tarjeta de entrada): no seguir el modo oscuro. */
  sobreClaro?: boolean;
}

/** Color de la lumbre: el mismo en claro y en oscuro. */
export const COLOR_LUMBRE = '#C8794A';

/**
 * El logo de myarinn: una casa con la lumbre dentro («arinn» es el hogar, el
 * fuego de la casa, en nórdico antiguo). La casa toma el color del texto
 * (currentColor), así que se adapta sola al modo oscuro. Los PNG del icono de
 * la app y del navegador salen del mismo dibujo: public/marca/myarinn.svg.
 */
export const Logo: React.FC<LogoProps> = ({ size = 40, className = '', sobreClaro = false }) => (
  <svg viewBox="0 0 64 64" width={size} height={size} fill="none" role="img" aria-label={NOMBRE_APP}
    className={`${sobreClaro ? 'text-gray-800' : 'text-gray-800 dark:text-gray-100'} shrink-0 ${className}`}>
    <path d="M10 29 L32 10 L54 29 V51 a3 3 0 0 1 -3 3 H13 a3 3 0 0 1 -3 -3 Z"
      stroke="currentColor" strokeWidth={4.5} strokeLinejoin="round" strokeLinecap="round" />
    <path d="M32 49c-5.6 0-8.6-3.6-8.6-7.8 0-4.9 4.3-7.1 5.6-12.4 3.6 2.6 5.5 5.6 5.7 8.6 1.4-.9 2.3-2.3 2.7-3.8 2.4 2.1 3.2 4.6 3.2 7.6 0 4.2-3 7.8-8.6 7.8z"
      fill={COLOR_LUMBRE} />
  </svg>
);
